export const version = '6.6-rc.1074';
